module.exports = __webpack_public_path__ + "img/grommets.92313a7a.svg";